import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from '../not-found/not-found.component';

const routes: Routes = [
  {
    path: 'projects',
    loadChildren: () =>
      import('./projects/projects.module').then((x) => x.ProjectsModule),
  },
  {
    path: 'employees',
    loadChildren: () =>
      import('./employees/employees.module').then((x) => x.EmployeesModule),
  },
  {
    path: 'employees-assignments',
    loadChildren: () =>
      import('./employees-assignments/employees-assignments.module').then(
        (x) => x.EmployeesAssignmentsModule,
      ),
  },
  {
    path: 'kanban-board',
    loadChildren: () =>
      import('./kanban-board/kanban-board.module').then(
        (x) => x.KanbanBoardModule,
      ),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./company-settings/company-settings.module').then(
        (x) => x.CompanySettingsModule,
      ),
  },
  {
    path: 'crm',
    loadChildren: () => import('./crm/crm.module').then((x) => x.CrmModule),
  },
  {
    path: 'statistics',
    loadChildren: () =>
      import('./statistics/statistics.module').then((x) => x.StatisticsModule),
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContentRoutingModule {}
